import { TreeSortMode } from '../../shared/models';
import { ReleaseNode, TreeState } from './tree-node';

export interface Release {
  id?: string;
  projectId: string;
  title: string;
  companyId: string;
  createdAt?: number;
  updatedAt?: number;
  assetTree?: ReleaseAssetItem[];
  assets?: ReleaseAssetItem[];
  notifiers?: string[];
}

export interface ReleaseSimple {
  id: string;
  title: string;
}

export interface ReleaseAssetSimple extends ReleaseSimple {
  assetId: string;
}

export enum ReleaseAssetEntityTypes {
  VERSION = 'VERSION',
  FILE = 'FILE',
}

export enum ReleaseAssetTypes {
  ReleaseFolder = 'RELEASE_FOLDER',
  Version = 'VERSION',
  File = 'FILE',
}

export interface ReleaseAssetItem {
  id?: string;
  parentId: string;
  assetType: ReleaseAssetTypes;
  assetId?: string | null;
  assetVersion?: number | null;
  displayName: string;
  createdAt?: number;
  updatedAt?: number;
  children?: ReleaseAssetItem[];
  previewImages?: string[];
  contentTypes?: string[];
  //the following fields are for display purpose
  signedURL?: string;
  contentType?: string;
}

export interface ReleaseHistory {
  releaseSectionId: string;
  createdAt: string;
  id: string;
  action: string;
  description: string;
  user: string;
}

export interface ReleaseDownloadInfo {
  id: string;
  releaseSectionId: string;
  downloadUrl: string;
  fileSize: number;
  createdAt: string;
  valid: boolean;
  inProgress: boolean;
}

export const ReleaseCreatedEvent = 'RELEASE_CREATED';

export enum ReleaseEvents {
  RELOAD_HISTORY = 'reloadReleaseHistory',
  RELEASE_UPDATED = 'releaseUpdated',
  RELEASE_CREATED = 'releaseCreated',
  RELEASE_DELETED = 'releaseDeleted',
}

export type ReleaseListResponse = {
  sections: Release[];
  map: Record<string, number[]>;
};
export type BuildReleaseTreeParams = {
  list: ReleaseListResponse;
  sortMode: TreeSortMode;
};
export type CreateReleaseParams = {
  projectId: string;
  companyId: string;
  optionId: string;
  versionNumber: number;
  displayName?: string;
};

export interface MoveReleaseAssetParams {
  projectId: string;
  releaseId: string;
  assetId: string;
  parentId: string;
}

export interface ReleaseTreeState extends TreeState<ReleaseNode> {
  releaseRecord: Record<string, ReleaseAssetSimple>;
  relatedOptions: readonly string[];
  list: ReleaseSimple[];
}

export interface AddToReleaseParams {
  optionId: string;
  optionName: string;
  version: number;
  projectId: string;
  releaseId: string;
}

export interface RemoveFromReleaseParams {
  optionId: string;
  versionNumber: number;
  projectId: string;
  releaseRecord: Record<string, ReleaseAssetSimple>;
}
